import { zodTransformFirestoreTimestampToDate } from "../../utils/zodUtils.mjs";
import { z as z$1 } from "zod";

// src/models/consultation/clinicalAvailabilitySyncState.ts
const firestoreDate = z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date());
/** Server freshness window (D): a successful sync younger than this is never re-run. */
const CLINICAL_AVAILABILITY_FRESH_FOR_MS = 15e4;
/**
* After a failed ping, the client may keep showing slots from the last successful
* sync until this window elapses (server clock, anchored at `lastSuccessAt`).
*/
const CLINICAL_AVAILABILITY_STALE_USABLE_MS = 6e5;
/** A lease older than this is dead; a hung holder cannot outlive it (fetch timeout is shorter). */
const CLINICAL_AVAILABILITY_LEASE_TTL_MS = 9e4;
/** Total Tellescope availability fetch budget, retries included. */
const CLINICAL_AVAILABILITY_FETCH_TIMEOUT_MS = 2e4;
/** Retry delay after the 1st, 2nd, 3rd+ consecutive failure. */
const CLINICAL_AVAILABILITY_BACKOFF_MS = [
	3e4,
	6e4,
	12e4
];
/** Backoff multiplier applied on Tellescope 429, capped at {@link CLINICAL_AVAILABILITY_RATE_LIMIT_BACKOFF_CAP_MS}. */
const CLINICAL_AVAILABILITY_RATE_LIMIT_BACKOFF_FACTOR = 4;
const CLINICAL_AVAILABILITY_RATE_LIMIT_BACKOFF_CAP_MS = 3e5;
/**
* Per-consult-type sync state under `tellescope_availability_slots`, kept apart
* from the large slots doc. Customers read it; only the server writes it.
*/
function clinicalAvailabilitySyncStateDocId(consultType) {
	return `availability_sync_state_${consultType}`;
}
const clinicalAvailabilitySyncErrorSchema = z$1.object({
	code: z$1.string(),
	message: z$1.string(),
	at: firestoreDate
});
const clinicalAvailabilitySyncStateSchema = z$1.object({
	/** Equals the slots doc `updatedAt` written by that sync. */
	lastSuccessAt: firestoreDate.nullable().optional(),
	refreshStartedAt: firestoreDate.optional(),
	leaseExpiresAt: firestoreDate.optional(),
	/** Fencing token of the current lease holder. */
	leaseOwner: z$1.string().optional(),
	/** Start of the fetch whose data is in the slots doc (written with `lastSuccessAt`); it reflects every write made before this instant. */
	lastFetchStartedAt: firestoreDate.optional(),
	/** Something changed (e.g. a booking) after `lastFetchStartedAt`; the next ping must sync again. */
	dirtyAt: firestoreDate.optional(),
	lastError: clinicalAvailabilitySyncErrorSchema.optional(),
	consecutiveFailures: z$1.number().int().nonnegative().default(0),
	nextRetryAt: firestoreDate.optional()
});

export { CLINICAL_AVAILABILITY_BACKOFF_MS, CLINICAL_AVAILABILITY_FETCH_TIMEOUT_MS, CLINICAL_AVAILABILITY_FRESH_FOR_MS, CLINICAL_AVAILABILITY_LEASE_TTL_MS, CLINICAL_AVAILABILITY_RATE_LIMIT_BACKOFF_CAP_MS, CLINICAL_AVAILABILITY_RATE_LIMIT_BACKOFF_FACTOR, CLINICAL_AVAILABILITY_STALE_USABLE_MS, clinicalAvailabilitySyncErrorSchema, clinicalAvailabilitySyncStateDocId, clinicalAvailabilitySyncStateSchema };
//# sourceMappingURL=clinicalAvailabilitySyncState.mjs.map